<template>
  <header class=""
          :class="{ 'active-menu': mobileMenuOpened, 'fill-bg': headerFixed }">
    <div class="header-wrapper w-100">
      <router-link :to="{ path: '/' }"
                   class="header-link">
        <img src="@/assets/svg/logo.svg"
             class="logo"
             alt="leroy logo" />
      </router-link>

      <div class="logo-text">
        Ваше антистресс <br> пространство
      </div>

      <div class="section-links desktop">
        <router-link :to="{ path: '/' }"
                     class="section-title">
          мини-игры
        </router-link>

        <router-link class="header-link"
                     to="popit">
          Интерьерный поп-ит
        </router-link>

        <router-link class="header-link"
                     to="mirror">
          Арт-зеркало
        </router-link>

        <router-link to="/puzzle"
                     class="header-link">
          Декоративный пазл
        </router-link>
      </div>

      <div class="section-links desktop">
        <router-link :to="{ path: '/promo', hash: '#promo-start' }"
                     @click.native="navigateTo('promo-start')"
                     v-scroll-to="'#promo-start'"
                     class="section-title">
          розыгрыш призов
        </router-link>

        <router-link :to="{ name: 'promo', hash: '#mechanics' }"
                     @click.native="navigateTo('mechanics')"
                     v-scroll-to="'#mechanics'"
                     class="header-link">
          Механика и призы
        </router-link>

        <a href="/rules.pdf"
           target="_blank"
           class="header-link">
          Правила
        </a>

        <router-link :to="{ name: 'promo', hash: '#winners' }"
                     @click.native="navigateTo('winners')"
                     v-scroll-to="'#winners'"
                     class="header-link">
          Победители
        </router-link>

        <router-link :to="{ name: 'promo', hash: '#faq' }"
                     @click.native="navigateTo('faq')"
                     v-scroll-to="'#faq'"
                     class="header-link">
          Вопросы-ответы
        </router-link>
      </div>

      <div class="section-links desktop">
        <router-link :to="{ path: '/psychologist-page', hash: '#psychologist-start' }"
                     @click.native="navigateTo('psychologist-start')"
                     class="section-title">
          мнение психолога
        </router-link>

        <router-link :to="{ path: '/psychologist-page', hash: '#article' }"
                     @click.native="navigateTo('article')"
                     class="header-link">
          Статья
        </router-link>

        <router-link :to="{ path: '/test' }"
                     class="header-link">
          Пройти тест
        </router-link>

        <router-link :to="{ name: 'psychologist-page', hash: '#recommendations' }"
                     @click.native="navigateTo('recommendations')"
                     v-scroll-to="'#recommendations'"
                     class="header-link">
          Рекомендации
        </router-link>
      </div>

      <div class="d-flex align-items-center">
        <a target="_blank"
           href="https://leroymerlin.ru/uslugi/proektirovanie-i-dizayn/sozdayte-vannuyu-komnatu-svoey-mechty/"
           class="button button-green">
          <p>спроектировать свою <br> ванную комнату<p>

          <p>></p>
        </a>

        <div class="">
          <div class="mobile-icon"
               @click="mobileMenuOpened = !mobileMenuOpened">
            <img src="@/assets/svg/icons/burger-opened.svg"
                 v-if="mobileMenuOpened" />

            <img src="@/assets/svg/icons/burger.svg"
                 v-if="!mobileMenuOpened" />
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-menu"
         :class="{ active: mobileMenuOpened }">
         <div class="section-links">
           <router-link :to="{ path: '/' }"
                        class="section-title"
                        @click.native="mobileMenuOpened = false">
             мини-игры
           </router-link>

           <router-link class="header-link"
                        to="popit"
                        @click.native="mobileMenuOpened = false">
             Интерьерный поп-ит
           </router-link>

           <router-link to="/puzzle"
                        class="header-link"
                        @click.native="mobileMenuOpened = false">
                       Декоративный пазл
           </router-link>

           <router-link  to="/mirror"
                         class="header-link"
                         @click.native="mobileMenuOpened = false">
             Арт-зеркало
           </router-link>
         </div>

         <div class="section-links">
           <router-link :to="{ path: '/promo', hash: '#promo-start' }"
                        @click.native="navigateTo('promo-start', true)"
                        v-scroll-to="'#promo-start'"
                        class="section-title">
             розыгрыш призов
           </router-link>

           <router-link :to="{ name: 'promo', hash: '#mechanics' }"
                        @click.native="navigateTo('mechanics', true)"
                        class="header-link">
             Механика и призы
           </router-link>

           <a href="/rules.pdf"
              target="_blank"
              class="header-link"
              @click="mobileMenuOpened = false">
             Правила
           </a>

           <router-link :to="{ name: 'promo', hash: '#winners' }"
                        @click.native="navigateTo('winners', true)"
                        v-scroll-to="'#winners'"
                        class="header-link">
             Победители
           </router-link>

           <router-link :to="{ name: 'promo', hash: '#faq' }"
                        @click.native="navigateTo('faq', true)"
                        v-scroll-to="'#faq'"
                        class="header-link">
             Вопросы-ответы
           </router-link>
         </div>

         <div class="section-links">
           <router-link :to="{ path: '/psychologist-page', hash: '#psychologist-start' }"
                        @click.native="navigateTo('psychologist-start', true)"
                        class="section-title">
             мнение психолога
           </router-link>

           <router-link :to="{ path: '/psychologist-page', hash: '#article' }"
                        @click.native="navigateTo('article', true)"
                        class="header-link">
             Статья
           </router-link>

           <router-link :to="{ path: '/test' }"
                        class="header-link"
                        @click.native="mobileMenuOpened = false">
             Пройти тест
           </router-link>

           <router-link :to="{ name: 'psychologist-page', hash: '#recommendations' }"
                        @click.native="navigateTo('recommendations', true)"
                        v-scroll-to="'#recommendations'"
                        class="header-link">
             Рекомендации
           </router-link>
         </div>
    </div>
  </header>
</template>

<script>

export default {
  name: 'Sidebar',

  data: () => ({
    headerFixed: false,
    mobileMenuOpened: false,
  }),

  mounted () {
    window.addEventListener('scroll', this.handleScroll, true);

    this.headerFixed = window.scrollTop > 10
  },

  unmounted () {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll (event) {
      this.headerFixed = event.target.scrollTop > 10
    },

    navigateTo(el, mobile = false) {
      let ele = document.getElementById(el)

      ele.scrollIntoView()

      if (mobile) {
        this.mobileMenuOpened = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
header {
  min-height: 100vh;
  height: 100vh;
  width: fit-content;
  max-width: 440px;
  position: fixed;
  top: 0;
  min-width: 248px;
  z-index: 991;
  width: 100%;
  background-color: transparent;
  background-position: top left;
  background-repeat: no-repeat;
  background-image: url('@/assets/svg/backgrounds/menu.svg');
  background-size: cover;
  padding-top: 55px;
  padding-left: 50px;

  @media (min-width: 999px) and (max-height: 800px){
    height: 100vh;
    max-width: 270px !important;
    padding-top: 30px;
    padding-left: 40px;
    background-position: top right;
    padding-top: 20px !important;
    padding-left: 20px !important;
    min-width: 248px;
  }

  @media(max-width: 1440px){
    height: 100vh;
    max-width: 335px;
    padding-top: 30px;
    padding-left: 40px;
    background-position: top left;
  }

  @media(max-width: 999px){
    max-height: 100px;
    padding-top: 0;
    height: 100%;
    min-height: 50px;
    min-width: 100vw;
    padding-left: 0;
    background-position: top;
    background-size: cover;
    background-position: bottom;
    transition: 2s all;
    background-image: url('@/assets/svg/backgrounds/menu-mob.svg');
  }

  @media(max-width: 768px){
    max-height: 100px;
  }

  @media(max-width: 576px){
    background-size: cover;
    max-height: 80px;
  }

  @media(max-width: 390px){
    max-height: 65px;
  }
}

.fill-bg {
  @media(max-width: 999px){
    transition: 2s all;
    background-image: url('@/assets/svg/backgrounds/menu-mob-scrolled.svg');
  }
}

.header-wrapper {
  @media(max-width: 999px){
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 90px;
    padding-top: 10px;
  }

  @media(max-width: 768px){
    padding-right: 30px;
  }

  @media(max-width: 500px){
    padding-right: 10px;
    padding-top: 5px;
  }

  @media(max-width: 330px){
    padding-right: 5px;
  }
}

.logo {
  margin-left: -38px;
  transition: .6s all;

  @media (min-width: 999px) and (max-height: 800px){
    margin-left: -34px;
    max-width: 180px;
  }

  &:hover {
    opacity: 0.85;
  }

  @media(max-width: 999px){
    margin-left: 0;
  }

  @media(max-width: 768px){
    max-width: 200px;
  }

  @media(max-width: 576px){
    max-width: 160px;
  }

  @media(max-width: 475px){
    max-width: 140px;
    margin-top: 10px;
    margin-left: -20px;
  }

  @media(max-width: 390px){
    max-width: 120px;
    margin-left: -10px;
    margin-top: 0;
  }

  @media(max-width: 375px){
    margin-top: 5px;
  }

  @media(max-width: 350px){
    max-width: 110px;
    margin-top: 10px;
  }

  @media(max-width: 320px){
    max-width: 100px;
  }
}

.logo-text {
  font-weight: 700;
  color: $dark-text;
  line-height: 110%;
  width: fit-content;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 30px;
  font-size: 24px;

  @media (min-width: 999px) and (max-height: 800px){
    font-size: 20px;
    margin-bottom: 20px !important;
  }

  @media (min-width: 999px) and (max-height: 640px){
    font-size: 18px;
  }

  @media (min-width: 999px) and (max-height: 640px){
    font-size: 18px;
  }

  @media(max-width: 999px){
    display: none;
  }
}

.section-links {
  width: fit-content;
  margin-bottom: 20px;

  @media (min-width: 999px) and (max-height: 800px){
    margin-bottom: 15px !important;
  }

  .section-title {
    color: $green;
    font-weight: 700;
    font-size: 22px;
    line-height: 130%;
    text-transform: uppercase;

    @media (min-width: 999px) and (max-height: 800px){
      font-size: 20px;
    }

    @media (min-width: 999px) and (max-height: 640px){
      font-size: 16px;
    }

    @media(max-width: 999px){
      font-size: 26px;
      line-height: 28px;
    }

    &.router-link-exact-active {
      text-decoration: underline;
    }
  }
}

.header-link {
  cursor: pointer;
  font-weight: 400 !important;
  color: $dark-text;
  text-decoration: none;
  font-size: 20px;
  line-height: 32px;
  transition: .4s all ease;
  font-family: $cera;

  @media (min-width: 999px) and (max-height: 800px){
    font-size: 18px;
    line-height: 26px;
  }

  @media (min-width: 999px) and (max-height: 640px){
    font-size: 16px;
    line-height: 22px;
  }

  &:hover {
    color: $green;
  }
}

.button {
  margin-left: 0;
  margin-top: 100px;

  @media(max-width: 1440px){
    margin-left: -25px;
    padding: 20px 20px;
    margin-top: 0;
  }

  @media (min-width: 999px) and (max-height: 800px){
    font-size: 16px;
    padding: 20px 13px;
    margin-top: 0;
    margin-left: 0px;
  }

  @media (min-width: 999px) and (max-height: 640px){
    margin-left: -10px;
  }

  @media(max-width: 999px){
    margin-left: 0px;
    padding: 20px 30px;
    margin-right: 20px;
    font-size: 18px;
  }

  @media(max-width: 576px){
    padding: 15px 25px;
    font-size: 16px;
    margin-top: 0px;
    margin-right: 10px;
  }

  @media(max-width: 475px){
    padding: 15px 30px;
    margin-right: 0;
  }

  @media(max-width: 430px){
    margin-right: 10px;
  }

  @media(max-width: 420px){
    margin-right: 0;
  }

  @media(max-width: 390px){
    padding: 10px 15px;
    margin-right: 15px;
  }

  @media(max-width: 375px){
    margin-right: calc(100vw - 97.4vw);
  }

  @media(max-width: 360px){
    margin-right: calc(100vw - 99vw);
  }

  @media(max-width: 350px){
    margin-right: calc(100vw - 97.4vw);
  }

  @media(max-width: 330px){
    padding: 10px;
    margin-right: 5px;
  }
}

.mobile-icon {
  transition: 1s all;
  margin-left: 30px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: none;
  align-items: center;
  justify-content: center;

  @media(max-width: 999px){
    display: flex;
    margin-top: -50px;
    margin-right: -30px;
  }

  @media(max-width: 768px){
    margin-top: -40px;
    margin-right: 0;
  }

  @media(max-width: 500px){
    margin-left: 20px;
    margin-top: -15px;
  }

  @media(max-width: 475px){
    margin-left: 5px;
    margin-top: -25px;
    margin-right: -5px;
  }

  @media(max-width: 350px){
    margin-left: 0px;
    margin-right: 0px;
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.9;
  }

  img {
    margin: 0;
    transition: 1s all;

    @media(max-width: 350px){
      width: 20px;
      height: 20px;
    }
  }
}

.mobile-menu {
  display: none;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 40px;
  padding-top: 30px;
  padding-bottom: 100px;
  position: absolute;
  width: 100vw;
  margin-top: -800px;
  transition: 0s all !important;
  z-index: 992;
  background-color: transparent;

  @media(max-width: 999px){
    display: flex;
  }

  @media(max-width: 375px){
    padding-top: 15px;
  }

  &.active {
    margin-top: 0px;
    transition: .8s all !important;
  }
}

a {
  display: block;
  width: fit-content;
}

p {
  margin-bottom: 0;
}

.desktop {
  @media(max-width: 999px){
    display: none;
  }
}

.active-menu {
  max-height: 750px;
  transition: .7s all;
  background-position: center bottom;
  background-size: 100%;
  background-image: url('@/assets/svg/backgrounds/mobile-menu.svg');
  z-index: 900;

  @media(max-width: 500px){
    max-height: 650px;
  }

  @media(max-width: 375px){
    max-height: 600px;
  }

  @media(max-width: 340px){
    max-height: 560px;
  }
}

.router-link-exact-active {
  color: $green;
}
</style>
